/**
 * Maps the current `.btn`/`.btn.primary`/`.btn.sm` vocabulary onto standard
 * MUI variant/color/size props — see the migration plan for the full mapping
 * table. No custom-named variants: `palette.primary.contrastText` already
 * makes `variant="contained" color="primary"` render correctly, so there is
 * nothing a named variant would buy here that standard props do not.
 */
import type { Components, Theme } from '@mui/material/styles';

export const MuiButton: Components<Theme>['MuiButton'] = {
	defaultProps: {
		disableElevation: true,
	},
	styleOverrides: {
		root: {
			borderRadius: 4,
			textTransform: 'none',
			letterSpacing: 0,
			fontWeight: 500,
			height: 36,
			/* Explicit, not assumed — `theme.typography.fontFamily` should already
         cascade here, but the OutlinedInput border bug (fixed alongside this)
         was exactly a case of "should cascade" not holding in practice for a
         nested MUI-internal element. Stated directly so this one can't drift
         the same way. */
			fontFamily: 'var(--font-sans)',
			fontSize: 'var(--fs-body)',
		},
		sizeSmall: {
			height: 30,
			fontSize: 'var(--fs-body)',
		},
	},
};
